import { trackedEvent } from "../../../common/events/reduxEventTracking";
enum TypeKeys {
    PAYMENT_METHOD_OPEN_TAB_VIEW = "PARTY/PAYMENT_OPEN_TAB_VIEWED",
}
export const actionCreators = {
    trackOpenTabPaymentMethodViewed: () => trackedEvent({ type: TypeKeys.PAYMENT_METHOD_OPEN_TAB_VIEW }),
};
